module.exports = __webpack_public_path__ + "static/img/icon2.82e6d975.png";